import { AnimatePresence, motion } from "framer-motion";

interface TimeoutModalProps {
  onClose: () => void;
  onExtend: () => void;
  isExtending?: boolean;
}

const TimeoutModal = ({ onClose, onExtend, isExtending = false }: TimeoutModalProps) => {
  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => onClose()}
      >
        <motion.div
          className="w-[340px] md:w-lg min-h-[445px] rounded-2xl shadow-lg p-6 flex flex-col justify-center
                     bg-[linear-gradient(to_bottom,_#54C6F9,_#A36AFF)] text-white"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ type: "spring", duration: 0.4 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-center flex-col gap-5 text-center">
            <svg
              width="145"
              height="144"
              viewBox="0 0 145 144"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1_1585)">
                <path
                  d="M119.099 16.7664V6.53857C119.099 4.89142 123.313 3.80872 123.94 6.60407C123.609 11.8711 124.609 18.1958 124.011 23.3357C123.849 24.7382 123.131 25.4606 121.711 25.6263C116.551 26.2216 110.196 25.2237 104.909 25.555C102.103 24.9309 103.189 20.7349 104.843 20.7349H115.727C107.354 13.3044 96.2065 8.21463 85.1249 6.17832C33.8296 -3.24804 -8.92614 45.8603 9.11446 94.9938C9.85543 97.0127 12.1519 101.037 12.3937 102.727C12.6974 104.832 10.9504 106.114 9.01772 105.47C8.07168 105.156 6.80449 102.182 6.32082 101.134C-11.2322 63.1025 9.35823 17.5447 48.5097 4.02064C72.7992 -4.36926 99.3871 0.604954 119.099 16.7664Z"
                  fill="white"
                />
                <path
                  d="M25.8994 127.28V137.508C25.8994 139.155 21.6857 140.238 21.0589 137.442C21.3917 132.177 20.3876 125.847 20.9873 120.711C21.1518 119.298 21.8773 118.584 23.2876 118.42C28.4493 117.827 34.8007 118.823 40.09 118.491C42.8953 119.115 41.8099 123.311 40.1558 123.311H29.2715C37.4357 130.626 48.4206 135.758 59.2527 137.876C111.295 148.051 154.111 97.6812 135.577 48.1355C134.961 46.4922 132.779 42.566 132.601 41.3176C132.117 37.9116 135.704 36.8886 137.654 40.5701C152.867 69.2865 143.406 106.953 118.939 127.272C91.9367 149.695 52.9419 149.454 25.8994 127.28Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1_1585">
                  <rect width="145" height="144" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p className="text-3xl font-kalameh">
              مهلت دسترسی شما به پایان رسیده است.
            </p>
            <p className="text-lg font-kalameh">
              جهت تمدید فقط به مدت 24 ساعت روی دکمه زیر کلیک کنید!
            </p>
            <button
              className="bg-[#54C6F9] text-lg font-kalameh py-2 px-10 text-center rounded-4xl disabled:opacity-60"
              onClick={onExtend}
              disabled={isExtending}
            >
              {isExtending ? "در حال تمدید..." : "تمدید مهلت"}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TimeoutModal;
